var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},[_c('div',{staticClass:"tabs__nav"},[_c('div',{staticClass:"tabs__nav__inner"},_vm._l((_vm.panes),function(pane){return _c('div',{key:pane.componentInstance._uid,staticClass:"tabs__label",class:{
          'tabs__label--active': _vm.activePane(
            pane.componentOptions.propsData.name
          )
        },on:{"click":function($event){return _vm.handleClick(pane.componentOptions.propsData.name)}}},[_vm._v(" "+_vm._s(pane.data.attrs.label)+" ")])}),0)]),_c('div',{staticClass:"tabs__contents"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }